import React from 'react';
import styles from './BioSection.module.css';

function BioSection({ bio }) {
  return (
    <div className={styles.container}>
      <span className={styles.sectionTitle}>자기소개</span>
      <div className={styles.card}>
        <p className={styles.bioText}>
          {bio || '자기소개가 없습니다.'}
        </p>
      </div>
    </div>
  );
}

export default BioSection;
